export default "__VITE_ASSET__DWuViV8V__"